<template>
  <Modal
    v-model="modal"
    :mask-closable="false"
    :footer-hide="true"
    :fullscreen="true"
    class-name="rwdChatBlock"
    :transfer="false"
  >
    <div class="bw">
      <div class="outcard chatBlock" v-if="cu.cuid">
        <div class="chatBlockHeader">
          <h2>
            {{cu.nickname}} ({{cu.account}})
            <img
              src="~assets/img/onlineblock/soundfilled001.png"
              class="bkIcon"
              v-if="!CuInBk"
            />
            <img src="~assets/img/onlineblock/soundfilled002.png" class="inbk" v-if="CuInBk" />
            <Icon type="md-close" @click="modal=false" />
          </h2>
          <div class="mt-5 mb-5 mr-45 right">
            <DlogSearchMobile
              :chatlist="dialog.chatlist"
              :searchWord.sync="searchWord"
              @getSearchMsg="getSearchMsg"
            />
            <ModalBlackUser :cu="cu" @getBlackList="getBlackList" />
          </div>
        </div>

        <div id="chatBlockbody">
          <div
            class="cardin"
            id="chat_block"
            @drop.prevent="onDrop"
            @dragover="dragover"
            @dragleave.self="dragleave"
          >
            <div v-for="(item,idx) in dialog.chatlist">
              <div class="chatway" :key="idx" v-if="item.id != username.maid" :id="idx">
                <div class="left">
                  <div class="chatwayblock">
                    <div class="name">
                      <p class="b">{{item.nickname}}</p>
                      <AvatarPic />
                    </div>
                    <div class="text">
                      <p class="t">{{item.time}}</p>
                      <div v-if="regex(item.innertext)">
                        <viewer>
                          <img :src="item.innertext" class="imgInInnertext" />
                        </viewer>
                      </div>
                      <div v-else class="chatcloudl">
                        <div v-if="searchWord" v-html="replace(item.innertext)"></div>
                        <div v-else>
                          <p>{{item.innertext}}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="chatway" :key="idx" v-if="item.id == username.maid" :id="idx">
                <div class="right">
                  <div class="chatwayblock">
                    <div class="text tr">
                      <p class="t">{{item.time}}</p>
                      <div v-if="regex(item.innertext)">
                        <viewer>
                          <img :src="item.innertext" class="imgInInnertext" />
                        </viewer> 
                      </div>
                      <div v-else class="chatcloudl tr">
                        <div v-if="searchWord" v-html="replace(item.innertext)"></div>
                        <div v-else>
                          <p style="text-align:start">{{item.innertext}}</p>
                        </div>
                      </div>
                    </div>
                    <div class="name tr">
                      <p class="b">{{item.nickname}}</p>
                      <AvatarPic :srcPic="username.image" style="position:absolute;right: 0" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="cardin textarea">
            <div class="stuffsBtnGroup">
              <div class="upImgStuff">
                <Upload
                  v-if="!CuInBk"
                  name="img"
                  action="/uploadImg"
                  :data="{ imgname: username.maid }"
                  accept=".jpg, .jpeg, .png"
                  :format="['jpg','jpeg','png']"
                  :before-upload="upImgBefore"
                  :show-upload-list="false"
                  style="display: inline-block"
                >
                  <button class="stuffBtn upImgbtn mb-5">
                    <span>
                      <img src="~assets/img/public/photolinear.png" class="mr-5" />
                    </span>上传图片
                  </button>
                </Upload>
                <div v-if="dialog.imgUrl" class="preview mb-0">
                  <div class="btg">
                    <button class="previewbtn confirm" @click="upimg">上傳</button>
                    <button class="previewbtn cancel" @click="cancelubimg">取消</button>
                  </div>
                </div>
                <viewer :class="{viewer:!dialog.imgUrl}">
                  <img :src="dialog.imgUrl" class="imgpreview" />
                </viewer>
              </div>
              <div class="qkStuff ml-5">
                <button class="stuffBtn qkBtn mb-5" @click="qkContentStatus= !qkContentStatus">
                  <span>
                    <img src="~assets/img/onlineblock/messagelineartable.png" class="mr-5" />
                  </span>快捷讯息
                </button>
              </div>
            </div>
            <div class="qkContent" v-if="qkContentStatus">
              <Menu active-name="1-1" :open-names="[1]" style="z-index:10;width: ;marginLeft:-20px">
                <MenuItem @click.native="qkmsgstatus = true" name="0-0" class="addQk">
                  <img src="~assets/img/onlineblock/labellinear.png" /> 新增问答
                </MenuItem>
                <Submenu v-for="(item, idx) in clas" :key="idx" :name="idx+1">
                  <template slot="title">{{ item.title }}</template>
                  <MenuItem
                    class="clasItem"
                    v-for="(it2,key2) in item.content"
                    :key="key2"
                    :name="`${idx+1}-${key2+1}`"
                    @click.native="setInnertext(it2.innertext)"
                    style="paddingLeft:23px;"
                  >{{ it2.innertext }}</MenuItem>
                </Submenu>
              </Menu>
            </div>
            <Row type="flex" justify="space-between">
              <Col span="18">
                <div class="input-textarea">
                  <Input
                    v-if="CuInBk"
                    type="textarea"
                    :autosize="{minRows: 3,maxRows: 5}"
                    placeholder="此用户再黑名单中 解除请至 客服设置→黑名单→解除黑名单"
                    disabled
                  />
                  <Input
                    v-else
                    type="textarea"
                    :autosize="{minRows: 3,maxRows: 5}"
                    placeholder="请填写讯息"
                    v-model="dialog.chatInnertext"
                    @keyup.enter.native="sendmsg"
                  >
                    <img :src="dialog.imgUrl" />
                  </Input>
                </div>
              </Col>
              <Col offset="1" span="5">
                <div class="gbtn" v-if="!CuInBk">
                  <div class="btn btn-submit" @click="sendmsg">
                    <p>传送</p>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
    <ModalQkmsg :qkmsgstatus.sync="qkmsgstatus" :clasArr="clasArr" @getQkmsg="getQkmsg" />
  </Modal>
</template>
<script>
import { mapGetters } from 'vuex'
import chatBlockMixins from '../mixins/chatBlockMixins'
export default {
  name: "ModalChatRwdBlock",
  mixins: [chatBlockMixins],
  components: {
    ModalQkmsg: () => import("./ModalQkmsg"),
    ModalBlackUser: () => import("./ModalBlackUser"),
    DlogSearchMobile: () => import("./DlogSearchMobile")
  },
  props: {
    chatBlockMobileStatus: {
      type: Boolean,
      required: true
    },
    connect: {
      type: Boolean,
      required: true
    },
    bkDialog: Boolean,
    searchStatus: Boolean,
    cu: Object,
  },
  data () {
    return {
      totalQkmsg: [],
      filterQkmsg: [],
      qkmsgvalue: "",
      tabStatus: true,
      clas: {},
      qkmsgstatus: false,
      clasArr: [],
      qkContentStatus: false,
      searchWord: ""
    }
  },
  watch: {
    cu (cu) {
      this.cuInBlackList(cu.cuid)
      this.history()
    }
  },
  computed: {
    ...mapGetters(["username"]),
    modal: {
      get () {
        return this.chatBlockMobileStatus
      },
      set (val) {
        this.dialog = {
          chatlist: [],
          uploadData: {},
          chatInnertext: "",
          imgUrl: "",
        }
        this.qkContentStatus = false
        this.$emit("update:chatBlockMobileStatus", val)
      }
    },
    rwdBkDialog: {
      get () {
        return this.bkDialog
      },
      set (val) {
        this.$emit("update:bkDialog", val)
      }
    },
    rwdSearchStatus: {
      get () {
        return this.searchStatus
      },
      set (val) {
        this.$emit("update:searchStatus", val)
      }
    },
  },
  mounted () {
    this.getQkmsg()
    this.history()
  },
  methods: {
    //拿快捷訊息的資料
    getQkmsg () {
      this.$axios
        .qkmsgsel()
        .then(res => {
          this.totalQkmsg = res;
          this.getclas()
        })
        .catch(err => console.error(err));
    },
    //篩選分類訊息
    clasQkmsg (gupid) {
      let tmearray = [];
      this.totalQkmsg.forEach(function (i) {
        if (i.clas === gupid) {
          tmearray.push(i);
        }
      });
      this.filterQkmsg = tmearray;
    },
    //分類訊息array -> object
    getclas () {
      this.$axios
        .qskgup()
        .then(res => {
          this.clasArr = res
          res.forEach((i, index) => {
            this.clasQkmsg(i.gupid)
            let t = { title: i.gupname, content: this.filterQkmsg }
            this.clas[index] = t
          })
          this.clas = Object.assign({}, this.clas)
        })
        .catch(err => console.error(err));
    },
    //快捷訊息設定
    setInnertext (text) {
      this.dialog.chatInnertext = text;
    },
    //搜尋後chatlist改顏色
    replace (text) {
      let replaceString = '<span class="searchText">' + this.searchWord + '</span>';
      return text.replace(this.searchWord, replaceString)
    },
  }
}
</script>
<style lang="less">
.rwdChatBlock {
  .ivu-modal-body {
    padding: 0;
  }
  .ivu-modal-close {
    display: none;
  }
  .ivu-icon-md-close {
    font-size: 24px;
    color: #fff;
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
  }
  .bw {
    margin: 0;
    #chatBlockbody {
      padding-top: 20px;
      padding-bottom: 20px;
      .btn {
        height: 32px;
        width: 64px;
        p {
          line-height: 32px;
        }
      }
      #chat_block {
        height: 65vh;
      }
    }
  }
  .stuffsBtnGroup {
    display: flex;
    position: relative;
    .qkBtn {
      background-color: #0080ff;
      padding: 3px 7px;
      border-bottom: solid 1px #0080ff;
      img {
        transform: translateY(3px);
      }
    }
  }
  .qkContent {
    .ivu-menu-item {
      font-size: 12px;
    }
  }

  .ivu-menu-item.ivu-menu-item-active.ivu-menu-item-selected {
    background-color: #0080ff;
    color: #fff;
  }
  .addQk.ivu-menu-item.ivu-menu-item-active.ivu-menu-item-selected {
    background: none;
    color: var(--main-black);
  }
}
</style>